import "prebid.js/modules/tappxBidAdapter";

import type {IPrebidJsBidder} from "header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/iPrebidJsBidder";
import type {HeaderBiddingConfig} from "header-bidding-client-base/modules/config/domain/headerBiddingConfig";
import {Bidders} from "header-bidding-base/modules/header-bidding/domain/bidders";
import {PrebidJsBaseBidder} from "./prebidJsBaseBidder";
import {TappxAdUnit} from "header-bidding-base/modules/config/domain/bidders/tappxConfig";

export class TappxBidder extends PrebidJsBaseBidder implements IPrebidJsBidder<TappxAdUnit> {
    public constructor(config: HeaderBiddingConfig) {
        super(config, Bidders.TAPPX);
    }
}
